;(function () {
  var interactionLoaded = false;
  var idleLoaded = false;
  var interactionPending = false;
  var activityEvents = ['pointerdown', 'touchstart', 'keydown', 'scroll'];

  function isIdleOnly(element) {
    return element.hasAttribute('data-femily-defer-until-idle');
  }

  function activateScriptPlaceholder(placeholder) {
    var script = document.createElement('script');
    Array.prototype.forEach.call(placeholder.attributes, function (attribute) {
      if (attribute.name !== 'type' && attribute.name !== 'data-src' && attribute.name !== 'data-femily-defer-until-idle') {
        script.setAttribute(attribute.name, attribute.value);
      }
    });
    if (placeholder.dataset.src) {
      script.src = placeholder.dataset.src;
    } else {
      script.text = placeholder.text;
    }
    script.type = 'text/javascript';
    placeholder.parentNode.replaceChild(script, placeholder);
  }

  function loadDeferredResources(includeIdleResources) {
    document.querySelectorAll('iframe.lazy[data-src]').forEach(function (frame) {
      if (!includeIdleResources && isIdleOnly(frame)) return;
      frame.src = frame.dataset.src;
      frame.removeAttribute('data-src');
    });

    document.querySelectorAll('script[data-src]:not([type="text/lazyload"])').forEach(function (script) {
      if (!includeIdleResources && isIdleOnly(script)) return;
      script.src = script.dataset.src;
      script.removeAttribute('data-src');
    });

    document.querySelectorAll('script[type="text/lazyload"]').forEach(function (placeholder) {
      if (!includeIdleResources && isIdleOnly(placeholder)) return;
      activateScriptPlaceholder(placeholder);
    });

    document.querySelectorAll('link[data-href]').forEach(function (link) {
      if (!includeIdleResources && isIdleOnly(link)) return;
      link.href = link.dataset.href;
      link.removeAttribute('data-href');
    });

    if (includeIdleResources) {
      idleLoaded = true;
      interactionLoaded = true;
    } else {
      interactionLoaded = true;
    }
    document.dispatchEvent(new CustomEvent('asyncLazyLoad'));
  }

  function scheduleInteractionLoad() {
    if (interactionLoaded || interactionPending) return;
    interactionPending = true;
    var load = function () {
      interactionPending = false;
      if (!interactionLoaded) loadDeferredResources(false);
    };
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(load, { timeout: 1200 });
    } else {
      window.setTimeout(load, 250);
    }
  }

  activityEvents.forEach(function (eventName) {
    window.addEventListener(eventName, scheduleInteractionLoad, { passive: true, once: true });
  });

  window.addEventListener('load', function () {
    window.setTimeout(function () {
      if (!idleLoaded) loadDeferredResources(true);
    }, 3500);
  }, { once: true });
}());



/* Femily: direct Shopify checkout for cart page and dynamically refreshed drawer. */
(function () {
  function getCheckoutUrl() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return (root || '/') + 'checkout';
  }

  function goToCheckout(button) {
    var form = button.closest('form[data-cart-wrapper]');
    var fullCart = form && form.classList.contains('t4s-cartPage__form');
    var destination = getCheckoutUrl();

    if (!fullCart) {
      window.location.assign(destination);
      return;
    }

    var data;
    try {
      data = new FormData(form);
    } catch (error) {
      window.location.assign(destination);
      return;
    }

    var finished = false;
    var fallback = window.setTimeout(function () {
      if (!finished) {
        finished = true;
        window.location.assign(destination);
      }
    }, 1200);

    fetch(form.getAttribute('action') || '/cart', {
      method: 'POST',
      body: data,
      credentials: 'same-origin',
      keepalive: true
    }).then(function () {
      if (finished) return;
      finished = true;
      window.clearTimeout(fallback);
      window.location.assign(destination);
    }).catch(function () {
      if (finished) return;
      finished = true;
      window.clearTimeout(fallback);
      window.location.assign(destination);
    });
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    var button = target && target.closest ? target.closest('button[name="checkout"]') : null;
    if (!button || button.disabled) return;
    if (!button.closest('#t4s-mini_cart') && !button.closest('form[data-cart-wrapper]')) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    button.disabled = true;
    goToCheckout(button);
  }, true);
}());
